class MintSingleton {
  #mint;
  #stateUpdateQueue;
  #isReady;
  #readyPromise;

  constructor() {
    // IMPORTANT: as of 01/10/2025, some transpilation issue is causing #stateUpdateQueue to not be initialized properly
    // when defined directly on the class properties. Setting them here in the constructor is a temporary fix until it
    // can be verified later that migrating to ESM (via Webpack), Vite, or Next.js incidentally resolves the issue.
    this.#stateUpdateQueue = [];
    this.#isReady = false;
  }

  get instance() {
    return this.#mint;
  }

  get isReady() {
    return this.#isReady;
  }

  get readyPromise() {
    return this.#readyPromise?.promise;
  }

  setup() {
    this.#readyPromise = Promise.withResolvers();
  }

  async init(options) {
    this.#mint = await import('@tunein/mint').then((module) => module.default);

    this.#mint.init(options);

    // IMPORTANT: don't remove the optional chain here, just in case. See note in constructor().
    if (this.#stateUpdateQueue?.length) {
      this.#stateUpdateQueue.forEach(([key, value]) => {
        this.#mint.updateState(key, value);
      });
    }

    this.#isReady = true;

    this.#readyPromise.resolve();

    // Cleanup for garbage collector
    this.#stateUpdateQueue = null;
    this.#readyPromise = null;
  }

  updateState(key, value) {
    if (!this.#isReady) {
      this.#stateUpdateQueue.push([key, value]);
      return;
    }

    this.#mint.updateState(key, value);
  }
}

export const mintSingleton = new MintSingleton();
